import {DataGrid, GridColumns} from "@mui/x-data-grid";
import React from "react";
import { ReleaseNoteModel } from "../../types/ReleaseNoteModel";
import {colors} from "../../colors";
import ProtectedIconButton from "../ui/ProtectedIconButton";
import {Feature} from "../../globalHooks/authorizationHooks";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

export const ReleaseNotesDataGrid = (
    { 
        releaseNotes,
        editButtonClickHandler,
        deleteButtonClickHandler,
    } : {
        releaseNotes: ReleaseNoteModel[],
        editButtonClickHandler: (releaseNote: ReleaseNoteModel) => void,
        deleteButtonClickHandler: (releaseNote: ReleaseNoteModel) => void,
    }) => {

    const columns : GridColumns<ReleaseNoteModel> = [
        {
            field: "version",
            headerName: "Version",
            flex: 2,
            valueGetter: (params) => `${params.row.version}`,
        },
        {
            field: "releaseDate",
            headerName: "Release Date (UTC)",
            flex: 2,
            valueGetter: (params) => `${params.row.timestampUtc.toLocaleDateString()}`,
            sortable: false
        },
        {
            field: "title",
            headerName: "Title",
            flex: 7,
            valueGetter: (params) => `${params.row.title ?? ""}`,
            sortable: false
        },
        {
            field: "actions",
            headerName: "Actions",
            flex: 1,
            renderCell: (params) => {
                return (
                    <>
                        <ProtectedIconButton
                            onClick={() => editButtonClickHandler(params.row)}
                            requiredFeature={ Feature.CustomerCareManageCustomerCareUser }
                            color={"primary"}
                            tooltip={"Edit release note"}
                        >
                            <EditIcon/>
                        </ProtectedIconButton>
                        <ProtectedIconButton
                            onClick={() => deleteButtonClickHandler(params.row)}
                            requiredFeature={ Feature.CustomerCareManageCustomerCareUser }
                            color={"primary"}
                            tooltip={"Delete release note"}
                        >
                            <DeleteIcon/>
                        </ProtectedIconButton>
                    </>
                );
            },
            disableColumnMenu: true,
            sortable: false,
            minWidth: 140,
        }
    ]
    
    return (
        <div style={{ height: 500, width: "100%" }}>
            <DataGrid
                rows={ releaseNotes }
                pageSize={ 20 }
                rowsPerPageOptions={[20]}
                getRowId={(row) => row.version}
                columns={ columns }
                sx={{
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.mobaBlue,
                        color: "white",
                    },
                    "& .MuiDataGrid-sortIcon, & .MuiDataGrid-filterIcon, & .MuiDataGrid-menuIconButton":
                        {
                            opacity: 1,
                            color: "white",
                        },
                    "& .MuiDataGrid-row": {
                        "&:nth-of-type(odd)": {
                            backgroundColor: colors.rowBackgroundColor,
                        },
                    },
                }}
                isRowSelectable={() => false}
            />
        </div>
    )
}